export default "__VITE_ASSET__DzTPGK9S__"